import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import axios from 'axios';

const containerStyle = {
  width: '100%',
  height: '400px'
};

const ReviewsComponent = ({ placeId }) => {
  const [reviews, setReviews] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  const [loading, setLoading] = useState(true);

  // جلب بيانات التقييمات من Google Places API
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(
          `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&fields=name,rating,reviews&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
        );
        
        if (response.data.result) {
          setReviews(response.data.result.reviews || []);
          setAverageRating(response.data.result.rating || 0);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching reviews:', error);
        setLoading(false);
      }
    };

    fetchReviews();
  }, [placeId]);

  // رابط التقييم المباشر
  const writeReviewUrl = `https://search.google.com/local/writereview?placeid=${placeId}`;

  return (
    <div className="reviews-section" >
      {/* <h2>تقييمات العملاء ⭐ ({averageRating})</h2>
      
      {loading ? (
        <p>جاري تحميل التقييمات...</p>
      ) : reviews.length > 0 ? (
        <div className="reviews-list">
          {reviews.slice(0, 5).map((review, index) => (
            <div key={index} className="review-card">
              <div className="review-header">
                <span className="rating">{review.rating} ⭐</span>
                <h4>{review.author_name}</h4>
              </div>
              <p className="review-text">{review.text}</p>
              {review.relative_time_description && (
                <small>{review.relative_time_description}</small>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p>لا يوجد تقييمات حتى الآن.</p>
      )} */}
{/* 
      <a
        href={writeReviewUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="review-button"
      >
        اكتب تقييمك
      </a> */}
      
      <a
        href="https://g.page/r/CQbjMpzGkCW_EBM/review"
        target="_blank"
        rel="noopener noreferrer"
        className="review-button"
      >
        اكتب تقييمك
      </a>

      {/* خريطة جوجل المصغرة */}
      <div className="map-container">
        {/* <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={{ lat: 24.7136, lng: 46.6753 }} // إحداثيات الموقع
            zoom={15}
          >
            <Marker position={{ lat: 24.7136, lng: 46.6753 }} />
          </GoogleMap>
        </LoadScript> */}
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3714.355935120027!2d39.3027902244318!3d21.415250280332565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3cbef8e572967%3A0xbf2590c69c32e306!2z2LXYp9mE2Kkg2KjZhNmK2KfYsdiv2Ygg2YPZiNmB2Yog2LTZiNioIPCfjrFQT0NLRVRT4oCO!5e0!3m2!1sar!2ssa!4v1745133651032!5m2!1sar!2ssa" 
        width="600" height="450" 
        style={{border:0,width:"100%"}} allowfullscreen="" 
        loading="lazy" referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </div>
    </div>
  );
};

export default ReviewsComponent;